"use strict";
var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var React = __importStar(require("react"));
var react_1 = require("react");
var ColorLookup_1 = __importDefault(require("../../utils/ColorLookup"));
var styled_components_1 = __importDefault(require("styled-components"));
var icon_names_1 = __importDefault(require("./icon-names"));
var StIcon = styled_components_1.default.i(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  font-size: ", ";\n  color: ", ";\n  &:before {\n      content: '", "';\n  }\n"], ["\n  font-size: ", ";\n  color: ", ";\n  &:before {\n      content: '", "';\n  }\n"])), function (_a) {
    var size = _a.size;
    return size;
}, function (_a) {
    var color = _a.color;
    return color;
}, function (_a) {
    var iconContent = _a.iconContent;
    return iconContent;
});
var StyledIcon = /** @class */ (function (_super) {
    __extends(StyledIcon, _super);
    function StyledIcon() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.genSize = function () {
            var size = _this.props.size;
            if (size) {
                if (size === 'small') {
                    return '1rem!important';
                }
                else if (size === 'medium') {
                    return '1.5rem!important';
                }
                else if (size === 'large') {
                    return '2rem!important';
                }
                else if (size === 'xlarge') {
                    return '4rem!important';
                }
                else {
                    return size + "!important";
                }
            }
            else {
                return undefined;
            }
        };
        _this.filterSelection = function () {
            var name = _this.props.name;
            var icoData = icon_names_1.default[name];
            return '\\' + icoData;
        };
        return _this;
    }
    StyledIcon.prototype.render = function () {
        var _a = this.props, rotated = _a.rotated, loading = _a.loading, padded = _a.padded, flipped = _a.flipped, size = _a.size, className = _a.className, root = _a.root, description = _a.description, exactSize = _a.exactSize, color = _a.color, name = _a.name, rest = __rest(_a, ["rotated", "loading", "padded", "flipped", "size", "className", "root", "description", "exactSize", "color", "name"]);
        var iconContent = this.filterSelection();
        return (React.createElement(StIcon, __assign({ className: this.genIconClass(), title: this.props.description || '', "aria-label": this.props.description || '', iconContent: iconContent, size: this.genSize(), color: color ? ColorLookup_1.default(color) : '' }, rest)));
    };
    StyledIcon.prototype.genIconClass = function () {
        var className = this.props.className;
        var classString = "h-icon common";
        if (className) {
            classString += ' ' + className;
        }
        return classString;
    };
    return StyledIcon;
}(react_1.Component));
exports.default = StyledIcon;
var templateObject_1;
